// extracted by mini-css-extract-plugin
export default {"list":"columns_list__eQB5z"};